const config = {
  version: '2.10.4',
  type: 'js'
};

export default config;


// WEBPACK FOOTER //
// ./src/config.ts